<h1 mat-dialog-title>Konieczna weryfikacja konta</h1>
<mat-dialog-content>
  <span
    >Funkcja autopłatności jest dostępna tylko dla zweryfikowanych użytkowników. Zweryfikuj konto numerem telefonu, aby
    móc ustawić autopłatność.</span
  >
</mat-dialog-content>
<mat-dialog-actions align="start">
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Zweryfikuj konto</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
